import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import bsCustomFileInput from 'bs-custom-file-input'
import {CompanyService} from '../../../shared/services/company.service';
import {catchError} from 'rxjs/operators';
import {empty} from '../../../functions';
import {ValidationService} from '../../../shared/services/validation.service';
import {ApiService} from '../../../shared/services/api.service';
import {faTimes, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {ModalService} from '../../../shared/services/modal.service';

@Component({
    selector: 'app-modal-company-profile-photo',
    templateUrl: './modal-company-profile-photo.component.html',
    styleUrls: ['./modal-company-profile-photo.component.scss'],
    standalone: false
})
export class ModalCompanyProfilePhotoComponent implements OnInit {

  // Icons
  faTimes = faTimes;
  faSpinner = faSpinner;

  isProcessing = false;
  isUploaded = false;

  data:any;

  public profile = {
    id: '',
  };

  public entity = {
    file: '',
    title: '',
    description: '',
    photoFile: <any> ''
  };

  filePhotoUrl: any = '';
  filePhotoName = '';

  validation:any = {
    validated: false,
    valid: false,
    fields: {
      entity: {
        photoFile: {
          regex: 'required',
          error: false
        }
      }
    }
  }

  view = {
    data: <any[]> []
  }


  /**
   * Constructor
   *
   * @param activeModal
   * @param api
   * @param alertService
   * @param companyService
   * @param validationService
   * @param modal
   */
  constructor(public activeModal: NgbActiveModal,
              private api: ApiService,
              private alertService: AlertService,
              private companyService: CompanyService,
              private validationService: ValidationService,
              private modal: ModalService) {


  }

  ngOnInit(): void {

    this.profile = this.data.profile;
    this.entity = this.data.entity;

    bsCustomFileInput.init();

    // Load existing images
    this.loadData();

  }

  // Get photo data of company
  loadData() {

    this.companyService.apiCompanyGetImages(this.profile.id).subscribe( (result:any) => {

      if (result) {

        const resultsFilter = result.filter( (item:any) => item.imageUri != null);

        this.view.data = Object.assign([], resultsFilter);
      } else {
        this.view.data = [];
      }

    });
  }

  /**
   * When file changes
   *
   * @param $event
   */
  onFilePhotoChange($event:any) {

    // Search for file name when input file changes
    if ($event.target.files && $event.target.files.length > 0) {

      for (let i = 0; i < $event.target.files.length; i++) {
        const file = $event.target.files[i];
        this.filePhotoUrl = URL.createObjectURL(file);
        this.filePhotoName = file.name;
      }
    }
  }

  /**
   * Add a new photo
   */
  addPhoto() {

    this.isUploaded = false;

    const valid = this.validateForm();

    if (valid) {

      this.isProcessing = true;

      // First add a new entry
      this.companyService.apiAddPhoto(this.profile.id, this.entity).pipe(catchError(this.companyService.handleError('apiAddPhoto', false))).subscribe( (result:any) => {

        if (result) {

          const image_id = result.id;

          fetch(this.filePhotoUrl)
            .then(res => res.blob())
            .then(blob => {
              const fd = new FormData();
              const file = new File([blob], this.filePhotoName);
              fd.append('file', file);

              // Finally upload the file
              const API_URL = this.api.getApiUrl() + '/company/' + this.profile.id + '/images/' + image_id + '/data' ;
              const headers = this.api.getUploadHeaders();
              fetch(API_URL, {method: 'POST', headers: headers, body: fd})
                .then((res) => {

                  this.isProcessing = false;

                  if (res.status == 200) {
                    this.loadData();
                    this.isUploaded = true;
                  } else {
                    // Some error
                  }


                }).catch( (error) => {
                this.isProcessing = false;
              })

            });

        } else {
          this.isProcessing = false;
        }

      });

    }


  }

  /**
   * Delete a single photo
   *
   * @param $id
   */
  deletePhoto($id: string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?', {}, [], {}, false).then( (confirm) => {
      if (confirm === true) {

        this.companyService.apiDeleteImage(this.profile.id, $id).pipe(catchError(this.companyService.handleError('apiDeleteImage', false))).subscribe( (result) => {

          if (result !== false){
            this.alertService.success(alertMessages.successDataRemoved);
            this.loadData();
          }

        });


      } else {

      }
    }).catch( (error) => {

    });

  }

  /**
   * Show validation error
   *
   * Determine if a validation error needs to be visible to client
   *
   * @param stepNumber
   * @param $entity
   * @param $entityProperty
   */
  showValidationError($entity: string, $entityProperty: string, $property:string = '') {

    if (!empty($property)) {
      if (this.validation['validated'] && this.validation['fields'][$entity][$entityProperty][$property]['error'] === true) {
        return true;
      } else {
        return false;
      }
    } else {
      if (this.validation['validated'] && this.validation['fields'][$entity][$entityProperty]['error'] === true) {
        return true;
      } else {
        return false;
      }
    }

  }

  /**
   * Validate the registration form
   */
  validateForm() {
    let valid = true;
    const self:any = this;

    // Set entity data selectors
    const $entitySelectors = ['entity'];

    // Check entity columns
    for (const $entitySelector of $entitySelectors) {

      if ( this.validation['fields'].hasOwnProperty($entitySelector) ) {

        for (const key in this.validation['fields'][$entitySelector]) {

          if (!empty(this.validation['fields'][$entitySelector][key])) {

            const entity = this.validation['fields'][$entitySelector][key];

            if (entity.hasOwnProperty('regex') ) {
              const value = self[$entitySelector][key];
              const regPattern = entity['regex'];

              // Set validation flags
              if (!this.validationService.regexValidation(regPattern, value)) {
                this.validation['fields'][$entitySelector][key]['error'] = true;
                valid = false;

              } else {
                this.validation['fields'][$entitySelector][key]['error'] = false;
              }

            }
          }
        }
      }
    }

    // Set validation flags for step
    this.validation['valid'] = valid;
    this.validation['validated'] = true;

    return valid;
  }

}
